import React from "react";
import * as PopoverPrimitives from "@radix-ui/react-popover";
import { cn } from "@RHCommerceDev/utils/cn";

const Popover = PopoverPrimitives.Root;

const PopoverTrigger = PopoverPrimitives.Trigger;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitives.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitives.Content>
>(({ className, children, ...props }, ref) => {
  return (
    <PopoverPrimitives.Portal>
      <PopoverPrimitives.Content
        onOpenAutoFocus={event => {
          event.preventDefault();
        }}
        onCloseAutoFocus={event => {
          event?.preventDefault();
        }}
        className={cn("z-[1100] shadow-popperBox", className)}
        {...props}
        ref={ref}
      >
        {children}
      </PopoverPrimitives.Content>
    </PopoverPrimitives.Portal>
  );
});
PopoverContent.displayName = PopoverPrimitives.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent };
